import { setSpecificMessage, maxWords } from "valibot";
setSpecificMessage(
  maxWords,
  (issue) => `Mots invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);